import { StateManager } from '../stateManager';

import { SET_NODE_LIST, SET_ERROR } from './actions';

export const initialState = {
  nodeList: [],
  isError: false,
};

const setNodeList = (state, action) => {
  let { node } = action;
  return { ...state, nodeList: [...node] };
};

const setError = (state, action) => {
  let { value } = action;
  return { ...state, isError: value };
};

const actions = {
  [SET_NODE_LIST]: setNodeList,
  [SET_ERROR]: setError,
};

const manager = new StateManager(initialState, actions);

export default manager.reducer;
